export default __webpack_public_path__ + "static/media/enter-answer-and-score-mc.efd7b9a9.gif";